import constants from './../constants';

const authorities: Mapping[] = [
  {label: '一般ユーザー', value: constants.AUTHORITIES.GENERAL},
  {label: '管理者', value: constants.AUTHORITIES.ADMIN},
  {label: '特権管理者', value: constants.AUTHORITIES.SUPER_ADMIN},
];

export default authorities;
